import type { SpecificResourceOverviewCardProps } from '@ctw/shared/content/overview/resource-overview-card';
import { withOverviewCardErrorBoundary } from '@ctw/shared/content/overview/with-overview-card-error-boundary';
import { useResourceDrawer } from '@ctw/shared/context/resource-drawer-context';
import { PatientReferralsOverviewCard } from './patient-referrals-overview-card';
import { usePatientReferralsOverviewData } from './use-patient-referrals-overview-data';

const TITLE = 'Referrals';

export const PatientReferralsOverview = withOverviewCardErrorBoundary({
  cardTitle: TITLE,
  boundaryName: 'PatientReferralsOverview',
  Component: ({ onSeeAllResources }: SpecificResourceOverviewCardProps) => {
    const { openResourceDrawer } = useResourceDrawer();
    const { data, isLoading } = usePatientReferralsOverviewData();

    return (
      <PatientReferralsOverviewCard
        footerCTA={{
          label: 'All Referrals',
          onClick: onSeeAllResources,
        }}
        onRowClick={({ telemetry, record }) => openResourceDrawer({ telemetry, model: record })}
        data={data}
        isLoading={isLoading}
        emptyState="We didn't find any referrals for this patient."
      />
    );
  },
});
